/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Guid } from "@contenteditor-shared/content-editor-common/src/Utils/Guid";
var TrackedLinkBuilder = /** @class */ (function () {
    function TrackedLinkBuilder(model) {
        this.WithBaseUrl(model)
            .WithFriendlyName(model)
            .WithIsShort(model)
            .WithDoNotTrack(model)
            .WithLinkId(model);
    }
    TrackedLinkBuilder.prototype.WithBaseUrl = function (value) {
        if (typeof value === "string") {
            this.url = value;
        }
        else if (value === null || value === void 0 ? void 0 : value.UrlPart) {
            this.url = value.UrlPart;
        }
        return this;
    };
    TrackedLinkBuilder.prototype.WithFriendlyName = function (value) {
        if (typeof value === "string") {
            this.isFriendlyNameDefined = true;
            this.friendlyName = value;
        }
        else if (value === null || value === void 0 ? void 0 : value.FriendlyName) {
            this.isFriendlyNameDefined = true;
            this.friendlyName = value.FriendlyName;
        }
        return this;
    };
    TrackedLinkBuilder.prototype.WithIsShort = function (value) {
        if (typeof value === "boolean") {
            this.isShortDefined = true;
            this.isShort = value;
        }
        else if ((value === null || value === void 0 ? void 0 : value.IsShort) != null) {
            this.isShortDefined = true;
            this.isShort = value === null || value === void 0 ? void 0 : value.IsShort;
        }
        return this;
    };
    TrackedLinkBuilder.prototype.WithDoNotTrack = function (value) {
        if (typeof value === "boolean") {
            this.doNotTrackDefined = true;
            this.doNotTrack = value;
        }
        else if ((value === null || value === void 0 ? void 0 : value.DoNotTrack) != null) {
            this.doNotTrackDefined = true;
            this.doNotTrack = value.DoNotTrack;
        }
        return this;
    };
    TrackedLinkBuilder.prototype.WithLinkId = function (value) {
        if (typeof value === "string") {
            this.linkId = value;
        }
        else if (value === null || value === void 0 ? void 0 : value.LinkId) {
            this.linkId = value.LinkId;
        }
        return this;
    };
    TrackedLinkBuilder.prototype.Build = function () {
        var chunks = [];
        var url = this.url || "";
        if (url.startsWith("#") || (url.startsWith("mailto:") && !this.doNotTrack) || url.startsWith("tel:")) {
            return this.url;
        }
        if (this.doNotTrackDefined) {
            chunks.push("_msdynmkt_donottrack=".concat(this.doNotTrack ? 1 : 0));
        }
        if (this.isFriendlyNameDefined) {
            chunks.push("_msdynmkt_fn=".concat(encodeURI(this.friendlyName)));
        }
        if (this.isShortDefined) {
            chunks.push("_msdynmkt_isshort=".concat(this.isShort ? 1 : 0));
        }
        chunks.push("_msdynmkt_linkid=".concat(encodeURI(this.linkId || Guid.new.guid)));
        if (!chunks.length) {
            return url;
        }
        return "".concat(url, "#").concat(chunks.join(","));
    };
    TrackedLinkBuilder.GenerateFriendlyName = function (link) {
        var e_1, _a;
        var _b, _c;
        var text = ((_b = link === null || link === void 0 ? void 0 : link.textContent) === null || _b === void 0 ? void 0 : _b.trim()) || ((_c = link === null || link === void 0 ? void 0 : link.querySelector("[alt]")) === null || _c === void 0 ? void 0 : _c.getAttribute("alt")) || "";
        var alias = "";
        try {
            for (var text_1 = __values(text), text_1_1 = text_1.next(); !text_1_1.done; text_1_1 = text_1.next()) {
                var char = text_1_1.value;
                if (/[a-zA-Z0-9]/.test(char)) {
                    alias += char.toLowerCase();
                }
                else if (char === " ") {
                    alias += "-";
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (text_1_1 && !text_1_1.done && (_a = text_1.return)) _a.call(text_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (!alias.length) {
            return null;
        }
        return alias;
    };
    return TrackedLinkBuilder;
}());
export { TrackedLinkBuilder };
